module.exports = __webpack_public_path__ + "img/t2.a54b8e2f.png";